import { render } from "./OrderFileUpload.vue?vue&type=template&id=39ca6a3d&scoped=true"
import script from "./OrderFileUpload.vue?vue&type=script&lang=js"
export * from "./OrderFileUpload.vue?vue&type=script&lang=js"

import "./OrderFileUpload.vue?vue&type=style&index=0&id=39ca6a3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ca6a3d"]])

export default __exports__